import { IS_USER_DATA, IS_USER_LOGOUT } from "../action/userActions";

const initialState = {
    Username: null,
    isLoggedIn: false,
    UserId: null,
    accessToken : null,
    refreshToken: null,
    isResetVerify: false
}

const userReducer = (state = initialState, action) => {
    switch (action?.type) {
        case IS_USER_DATA:
            return{
                ...state,
                UserEmail: action.payload.UserEmail,
                UserId: action.payload.UserId,
                isLoggedIn: action.payload.isLoggedIn,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
                isResetVerify: action.payload.isResetVerify
            }  
        case IS_USER_LOGOUT:
            return{
                ...initialState,
                isLoggedIn: false,
            }  
        default:
            return state;
    }
}

export default userReducer;